import React, { useState, useEffect } from "react";
import { Grid, Card, CardContent, CardMedia, Typography, CircularProgress, Box } from "@mui/material";
import { fetchBlogCategories } from "../../../apiservices/ApiService";
import CategoryDetails from "./CategoryDetails";

const CategoriesScreen = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchBlogCategories();
        setCategories(data.categories || []);
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Show category details if a category is selected
  if (selectedCategory) {
    return <CategoryDetails category={selectedCategory} onBack={() => setSelectedCategory(null)} />;
  }

  return (
    <Grid container spacing={2} sx={{ padding: 2, backgroundColor: "rgba(255, 152, 0, 0.11)" }}>
      {categories.map((category, index) => (
        <Grid item xs={6} sm={4} key={index} onClick={() => setSelectedCategory(category.category)}>
          <Card
            variant="outlined"
            sx={{
              textAlign: "center",
              padding: 2,
              background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)",
              border: "1px solid #771615",
              boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
            }}
          >
            <CardMedia
              component="img"
              image={category.image}
              alt={category.display_cat}
              sx={{ height: 80, width: 80, margin: "0 auto", objectFit: "contain" }}
            />
            <CardContent>
              <Typography variant="body1" fontWeight="bold" sx={{ marginTop: 1, color: "#771615" }}>
                {category.display_cat}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CategoriesScreen;